import {COMPARATOR} from 'Core/const/global';
import {get} from 'lodash';
import {getObjectKeyByValue} from 'Core/helpers/data';

/**
 * Map external comparators to internal values
 */
export const COMPARATOR_MAP = {
	EQ: COMPARATOR.EQ, 
	NEQ: COMPARATOR.NEQ, 
	IN: COMPARATOR.IN, 
	NOT_IN: COMPARATOR.NOT_IN, 
	GT: COMPARATOR.GT, 
	GTE: COMPARATOR.GTE, 
	LT: COMPARATOR.LT, 
	LTE: COMPARATOR.LTE, 
	LIKE: COMPARATOR.LIKE, 
	STARTS_WITH: COMPARATOR.STARTS_WITH, 
	ENDS_WITH: COMPARATOR.ENDS_WITH, 
	CONTAINS: COMPARATOR.CONTAINS,
	NOT_CONTAINS: COMPARATOR.NOT_CONTAINS,
	NULL: COMPARATOR.NULL,
	NOT_NULL: COMPARATOR.NOT_NULL,
	BTW: COMPARATOR.BTW,
};

/**
 * Get input data from raw data
 * @param {string} rawData - Raw data received from IO.
 * @return {ConditionListComparator}
 */
export const input = rawData => get(COMPARATOR_MAP, rawData);

/**
 * Get output data from input data
 * @param {ConditionListComparator} inputData - Input data.
 * @return {string}
 */
export const output = inputData => getObjectKeyByValue(COMPARATOR_MAP, inputData);